import { Box } from '@mui/material';

const DASHBOARD_URL = 'http://localhost:3333';

export const PipelineDashboard = () => {
    return (
        <Box
            sx={{
                height: 'calc(100vh - 48px)',
                width: '100%',
                overflow: 'hidden',
            }}
        >
            <iframe
                src={DASHBOARD_URL}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                }}
                title="Pipeline Dashboard"
            />
        </Box>
    );
};
